import {DataTableColumn} from 'mantine-datatable';
import {I18n} from '@aws-amplify/core';
import {NavLink} from 'react-router-dom';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Application} from '../types';
import {ApplicationStatusBadge} from '../profile/ApplicationStatusBadge';
import {ApplicationCategoryBadge} from '../profile/ApplicationCategoryBadge';

// FNP-913: was `tables/columns.tsx` — a bare array with NO `accessor` on any
// column, every one `render`-only.
//
// That distinction is the whole reason this module could not sort. `render`
// controls how a cell LOOKS; `accessor` is what sorting sorts BY. A render-only
// config looks complete in review and makes sorting structurally impossible —
// you cannot add `sortable: true` to a column that has nothing to sort on.
//
// Moved into a hook to match every other current module (the checklist's §3z).
export const useApplicationsTableColumns = () => {

    const columns: DataTableColumn<Application>[] = [
        {
            accessor: 'name',
            sortable: true,
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Application) => (
                <NavLink to={`/applications/${item.id}`}>{item.name}</NavLink>
            ),
        },
        {
            accessor: 'url',
            sortable: true,
            title: I18n.get('URL'),
            width: '1fr',
            // Nullable — renders the em-dash placeholder rather than blank, and
            // sorts LAST in both directions (see utils/sortRecords.ts).
            render: (item: Application) => item.url ?? '—',
        },
        {
            accessor: 'applicationCategory',
            sortable: true,
            title: I18n.get('Category'),
            width: '1fr',
            render: (item: Application) => <ApplicationCategoryBadge record={item}/>,
        },
        {
            accessor: 'applicationStatus',
            sortable: true,
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: Application) => <ApplicationStatusBadge record={item}/>,
        },
        {
            accessor: 'created',
            sortable: true,
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Application) => formatTimestamp(item.created),
        },
    ];

    return {columns};
};
